import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function patchRepairExtra(id, data) {
  return await getAPIResponse(`/v1/repair-extras/${id}`, data, 'PATCH');
}
